import { StaffRequestStatus } from "utils/choices";

export const staffRequestStatusLabel = status => StaffRequestStatus.find(s => s.id === status)?.name ?? "-";
